<template>
    <!-- Render the heading dynamically based on the `level` prop -->
    <component :is="tag" :class="titleClass || defaultTitleClasses">
        {{ title }}
    </component>

    <!-- Render subtitle if provided -->
    <p v-if="subtitle" :class="subtitleClass || defaultSubtitleClasses">
        {{ subtitle }}
    </p>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
    title: { type: String, required: true },
    subtitle: { type: String, default: '' },
    level: { type: Number, default: 1, validator: (val) => val >= 1 && val <= 6 },
    titleClass: { type: String, default: '' },
    subtitleClass: { type: String, default: '' },
})

const tag = computed(() => `h${props.level}`)

const defaultTitleClassesMap = {
    1: 'text-2xl md:text-3xl font-bold text-slate-800',
    2: 'text-xl sm:text-2xl md:text-2xl font-bold text-slate-800',
    3: 'text-lg sm:text-xl md:text-xl font-bold text-slate-800',
    4: 'text-base md:text-lg font-bold text-slate-800',
    5: 'text-sm md:text-base font-bold text-slate-800',
    6: 'text-xs md:text-sm font-bold text-slate-800',
}

const defaultTitleClasses = computed(() => defaultTitleClassesMap[props.level] || defaultTitleClassesMap[6])
const defaultSubtitleClasses = computed(() => 'mt-1 text-sm text-muted-foreground')
</script>
